import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../shared/user-login/login.service';
import { TicketService } from 'src/app/shared/customer/ticket/ticket.service';
import { ModeratorService } from 'src/app/shared/moderator/moderator.service';
import { ExpertService } from 'src/app/shared/techExpert/expert.service';
import { CustomerService } from '../shared/customer/customer.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { ConstantPool } from '@angular/compiler';
import { Alert } from 'selenium-webdriver';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})

export class HomeComponent implements OnInit {
  userDetails;
  role: string;
  loading: boolean = true;
  bankdetailsNeeded: boolean = true;
  ticket;
  assignedTickets;
  fullName;
  assignedTickets_cust=0;
  unassignedTickets;
  experts = [];
  closedTickets;
  resolvedTickets;
  pending;
  resolved;
  raisedtickets;
  cust_tickets_resolved;
  cust_tickets_pending;
  gt24pending=0;
  gt24unassignedTickets=0;
  gt24assignedTickets=0;
  username;
  serverErrorMessages: string;
  closeResult: string;
  myDate = new Date();
  date
  balance: any;
  x
  constructor(private loginService: LoginService, private expertService: ExpertService, private moderatorService: ModeratorService, private ticketService: TicketService, private customerSevice: CustomerService, private modalService: NgbModal, private datePipe: DatePipe, private router: Router) {
    this.date = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
   }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
        
          this.userDetails = res['user'];
          this.x = 'Welcome '+this.userDetails.fullName
          this.username=this.userDetails.fullName;
          //console.log("Userdetails"+this.userDetails.fullName)
          if(!localStorage.getItem('firstTimeLogin')){
            localStorage['firstTimeLogin'] = true
          }
          else{
            // localStorage.removeItem('firstTimeLogin')
          }
          this.role = res['user'].role;
          
          //Check if bank details are updated, if true update bankdetailsNeeded to false
          switch (this.role) {
            case 'CUSTOMER': this.getLatestTicket(); this.getCurrentBalanceForCustomer();break;
            case 'MODERATOR': this.getTicketsStat(); this.getAllExperts(); break;
            case 'TECHEXPERT': this.getStatus(); break;
          }
         //console.log('USER', this.userDetails, this.role);
          this.loading = false;
          if(!localStorage.getItem('firstLoad')){
            localStorage['firstLoad'] = true;
            window.location.reload()
          }
          else{
            localStorage.removeItem('firstLoad');
          }
        },
        err => {
         //console.log('Did not get user', err);
          this.loading = false;
        });
    }
    else{
     //console.log('NO USER')
      this.router.navigateByUrl('/signin');
      this.loading = false;
    }
  }

  onLogout(){
    this.loginService.deleteToken();
    this.router.navigateByUrl('/signin');
  }


  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

getStatus() {
    this.expertService.getAllTickets().subscribe(
      res => {
        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

        this.pending = res['pending']?.length;
        this.resolved = res['resolved']?.length;
        for(var i=0;i<this.pending;i++){
        var d1=new Date(res['pending'][i]['createdAt']);
        var d2=new Date(today);
        var diff = d2.getTime() - d1.getTime();  
        var daydiff = (diff / (1000 * 60 * 60 * 24))-1;   
        
        if(daydiff > 1){
        this.gt24pending=this.gt24pending+1;
        }       
      }
     },
      err => {
        //this.serverErrorMessages = err.erros.message
       //console.log('error getting experts', err)
      }
    )
  }
  
  //MODERATOR
  getTicketsStat(){
    this.moderatorService.getAllTickets().subscribe(
      
      res => {
        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

        this.assignedTickets = res['ticketAssigned']?.length;
        this.unassignedTickets = res['ticketNotAssigned']?.length;
       //console.log('Got assigned and unassigned tickets', res);

//for > 24 hours assigned tickets pending 

       for(var i=0;i<this.assignedTickets;i++){
        var d1=new Date(res['ticketAssigned'][i]['createdAt']);
        var d2=new Date(today);
        var diff = d2.getTime() - d1.getTime();  
        var daydiff = (diff / (1000 * 60 * 60 * 24))-1;   
        
        if(daydiff > 1){
        this.gt24assignedTickets=this.gt24assignedTickets+1;
        }       
      }

//for >24 hours un assigned tickets pending 

      for(var i=0;i<this.unassignedTickets;i++){
        var d1=new Date(res['ticketNotAssigned'][i]['createdAt']);
        var d2=new Date(today);
        var diff = d2.getTime() - d1.getTime();  
        var daydiff = (diff / (1000 * 60 * 60 * 24))-1;   
        
        if(daydiff > 1){
        this.gt24unassignedTickets=this.gt24unassignedTickets+1;
        }       
      }


      },
      err => {
       //console.log('Error getting tickets')
      }
    )
    this.moderatorService.getClosedTickets().subscribe(
      res => {
      this.closedTickets = Object.keys(res)?.length;
    // alert("closed tickets"+(this.closedTickets)?.length)
      console.log('Got closed tickets', res);
      },
      err => {
       //console.log('Error getting closed tickets')
      }
    )
  }

  getAllExperts(){
    this.moderatorService.getAllExperts().subscribe(
      res => {
        this.experts = res['techExperts']
       //console.log('Got Experts', this.experts)
      },
      err => {
        this.serverErrorMessages = err.erros.message
       //console.log('error getting experts', err)
      }
    )
  }

  //CUSTOMER
  getLatestTicket(){

    this.moderatorService.getAllTickets().subscribe(
      
      res => {
               
        var fullName=res['ticketAssigned'][0]['customer']['fullName'];
        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        


        this.cust_tickets_resolved = res['resolved']?.length;
        this.assignedTickets_cust = res['ticketAssigned']?.length;
        this.unassignedTickets = res['ticketNotAssigned']?.length;
       //console.log('Got assigned and unassigned tickets', res);

//for > 24 hours assigned tickets pending 

       for(var i=0;i<this.assignedTickets;i++){
        var d1=new Date(res['ticketAssigned'][i]['createdAt']);
        var d2=new Date(today);
        var diff = d2.getTime() - d1.getTime();  
        var daydiff = (diff / (1000 * 60 * 60 * 24))-1;   
        
        if(daydiff > 1){
        this.gt24assignedTickets=this.gt24assignedTickets+1;
        }       
      }

//for >24 hours un assigned tickets pending 

      for(var i=0;i<this.unassignedTickets;i++){
        var d1=new Date(res['ticketNotAssigned'][i]['createdAt']);
        var d2=new Date(today);
        var diff = d2.getTime() - d1.getTime();  
        var daydiff = (diff / (1000 * 60 * 60 * 24))-1;   
        
        if(daydiff > 1){
        this.gt24unassignedTickets=this.gt24unassignedTickets+1;
        }       
      }


      },
      err => {
       //console.log('Error getting tickets')
      }
    )


    this.ticketService.getAllTickets().subscribe(
      res => {
        
        this.ticket = res['tickets'][res['tickets']?.length-1];
        this.raisedtickets = res['tickets']?.length;        

       //  this.cust_tickets_pending = res['pending']?.length;        
        // this.cust_tickets_resolved = res['resolved']?.length;
    
        if (this.ticket){}
         //console.log('Got latest tickets', this.ticket);
        else{}
          //console.log('No tickets to show');

      },
      err => {
       //console.log('Error getting ticket', err)
        this.serverErrorMessages = err.error.message;
      }
    )
  }
  
  getCurrentBalanceForCustomer(){
    this.customerSevice.getCurrentBalance().subscribe(
      res => {
       //console.log('got balace', res);
        this.balance = res['balance'][0]['credit'];
        if(this.balance <= 10){
          alert("Your credit points are low....Please subscribe your account");
          return false;
        }
        this.customerSevice.balanceEmitter.next(res['balance'][0]['credit']);
        localStorage.setItem('balance', JSON.stringify(res['balance'][0]['credit']));
      },
      err => {
       //console.log('error getting balance', err)
      }
    )
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
}
